export default "<div id=\"map\"></div>";